import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CustomLink from '@/bit/components/components.custom-link';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@/bit/components/components.text';
import { saveAs } from 'file-saver';
import { reportJSError } from '@/utils/common';
import isWebview from '@gcloud-npm/utils.common.is-webview';
import isColApp from '@gcloud-npm/utils.common.is-colapp';

export const DOWNLOAD_FILE_NAME = 'ResumenContrato';
export const PDF_LINK_TEXT = 'Descarga del resumen del contrato (PDF).';

function ProvisionalAgreementLink({ urlDocument, className, cyData }) {
  const context = useSelector((state) => state.main.context);
  const handleOnClick = () => {
    try {
      saveAs(urlDocument, DOWNLOAD_FILE_NAME);
    } catch (error) {
      reportJSError(
        error,
        'downloadProvisionalAgreement',
        'components/provisionalAgreementLink',
        context
      );
      window.open(urlDocument, '_blank');
    }
  };

  return (
    <CustomLink
      onClick={!isWebview() && !isColApp() ? handleOnClick : null}
      href={(isWebview() || isColApp()) && urlDocument}
      target="_blank"
      taggingInfo={{
        componentVariation: 'all',
        componentContent: PDF_LINK_TEXT,
        componentProduct: '',
        componentName: 'link',
      }}
      className={!isWebview() && !isColApp() && className}
      cyData={cyData}
    >
      <Text
        className={(isWebview() || isColApp()) && className}
        text={PDF_LINK_TEXT}
        size={TEXT_SIZE.CAPTION2}
        color={TEXT_COLOR.BLUEA}
      />
    </CustomLink>
  );
}

ProvisionalAgreementLink.propTypes = {
  className: PropTypes.string,
  urlDocument: PropTypes.string,
  cyData: PropTypes.string,
};

ProvisionalAgreementLink.defaultProps = {
  className: '',
  urlDocument: '',
  cyData: '',
};

export default ProvisionalAgreementLink;
